import React from 'react';
import { InputStyled } from 'components/Form2/styled';
import { MAX_LENGTH_TEXT } from 'constant/inputMaxlength';
import { CHECK_MOBILE_NUMBER } from 'constant/regex';
import LabelForm from 'components/Form/LabelForm';
import FormMessage from 'components/Form/FormMessage';
import FormItem from 'components/Form2/FormItem';
import useMultiLanguageRegisterAccount from 'page/Application/ManageAccountSoliton/RegisterAccountSoliton/hook/useMultiLanguageRegisterAccount';

const FormValidateTextAndNumber = ({
  maxLength,
  disabled,
  name,
  label,
  required,
  placeholder,
  textRequired,
  isPhone,
  onChange,
  extra,
}) => {
  const { REGISTER_ACCOUNT_CATEGORY_ENTRY_REQUIRED } =
    useMultiLanguageRegisterAccount();
  return (
    <FormItem
      extra={extra}
      name={name}
      label={label ? <LabelForm text={'form label validate text'} /> : false}
      rules={[
        {
          required: required,
          message: (
            <FormMessage
              text1={
                textRequired
                  ? textRequired
                  : REGISTER_ACCOUNT_CATEGORY_ENTRY_REQUIRED
              }
              marginBottom={'12px'}
            />
          ),
        },
        () => ({
          validator(_, value) {
            if (isPhone) {
              if (!CHECK_MOBILE_NUMBER.test(value)) {
                return Promise.reject(
                  <FormMessage
                    text1={
                      '無効な文字列です。入力可能な文字列は0～9までの数字とハイフン(2つまで)です。'
                    }
                    marginBottom={'12px'}
                  />,
                );
              }
            }
            return Promise.resolve();
          },
        }),
      ]}
    >
      <InputStyled
        onChange={onChange}
        size="large"
        type="text"
        disabled={disabled}
        maxLength={maxLength ? maxLength : MAX_LENGTH_TEXT}
        placeholder={placeholder}
      />
    </FormItem>
  );
};

export default FormValidateTextAndNumber;
